import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import downloadFileFromS3, {
  validateAdmin,
  numberInputOnWheelPreventChange,
  currencyFormatter,
  extractURLAndEncodedFilename,
  calculateCP,
  isValidFileName,
} from "../../utils/helper";
import { Modal as AntModal } from "antd";


const defaultPart = {
  cncMaterial: null,
  cncSurfaceFinish: null,
  cncHeatTreatment: null,
  cncTolerance: null,
  cncPartMarking: null,
  cncReviewMyDesign: null,
  cncInternalCorner: null,
  threeDTechnology: null,
  threeDMachine: null,
  threeDMaterial: null,
  threeDPostProcessing: null,
  qty: 1,
  partNotes: '',
  description: '',

  partName: '',
  selectedFile: null,
  importedselectedFile: null,
  twoDFile: null,
  importedtwoDFile: null,
};



import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchRFQById,
  getAllSuppliers,
  updateOfferPartsData,
  createSupplierRFQ,
  getSupplierRFQsForRFQ,
  handleUpdateRfQ,
  sendOfferoSupplier,
  markRFQAsSent,
  deleteRFQ,
  downloadRfq,
  createPurchaseOrder,
  updateRFQAdminComment,
  cancelRFQ,
  uploadFileToRFQ,
  deleteFileFromRFQ,
  getPOBySupplierRFQId,
  uploadRFQDocumentByAdmin,
  activateRFQ,
  fetchOfferById,
  createPurchaseOrderOffer,
  downloadBatchFileSupplier,
  getDataSupplier,
  updateOfferAndRFQProjectName,
  getOtherRFQOfferData,
} from "../../utils/actions/supplierActions";
import Sidebar from "../Sidebar";
import {
  fetchQuoteById,
  fetchQuoteByQuoteId,
  getMaterial,
  getOrderForQuotationId,
  processFileWithAnalysis,
} from "../../utils/actions/allactions";
import downloadImg from "../../images/download.svg";
import deleteImageEnabled from "../../images/reddelete.svg";
import Switch from "react-input-switch";
import ChatButton from "../../Chat/ChatButton";
import Chat from "../../Chat";
import { ChatRefContext } from "../../context/chatRef.context";
import { Button, Modal, Row, Col, Form, Table } from "react-bootstrap";
import moment from "moment";
import useDocumentTitle from "../../utils/useDocumentTitle";
import { load3DViewer } from "../../utils/trigger";
import CaptchaModal from "../../components/CaptchaModal/CaptchaModal";
import { Loading } from "../../components/Loading";
import { DeleteIcon, DownloadIcon, EditIcon, LucidLoader, UploadIcon } from "../../components/Icons";
import RFQTableMasterMaterial from "../../components/RfqDetailsTableComponent/RFQTableMasterMaterial";
import { getAllMachineDataWithPopulation, getAllTechnology } from "../../utils/actions/adminActions";
import MetaDataInfoCncComponent from "../../components/OfferRfqDetails/MetaDataInfoCncComponent";
import { getAllMaterialsList, getPresignedUrlForFile } from "../../api/helperapi/helperApi";
import MetaDataInfoThreeDComponent from "../../components/OfferRfqDetails/MetaDataInfoThreeDComponent";
import { getQuotePartsDataById } from "../../api/customer/quotation/commonQuotationApi";
import ThreeDViewerComponent from "../../components/ViewerComponent/ThreeDViewerComponent";
import BackButtonWarning from "../../components/BackButtonComponent/BackButtonWarning";
import { useInstance } from "../../context/instance.context";
import { fetchOrganzationDetails, getData, getDFMInfo } from "../../api/customer/masters/commonMastersApi";
import { getOrganizationAddresses } from "../../api/customer/masters/adminMastersApi";
import EmailModal from "../EmailModal/EmailModal";
import FileImportModal from "../../components/FileImportLoader/FileImportLoader";
import FileName from "../../components/FileNameWithDownloadAndDelete/FileNameWithDownloadAndDelete";
import { useUnsavedChanges } from "../../context/UnsavedChangesContext";
import RFQOfferEditProjectName from "../../components/EditProjectName/RFQOfferEditProjectName";
import { deletePartSnapShotDataOfferRFQ, uploadPartSnapShotDataOfferRFQ } from "../../api/supplier/rfqs/adminRfqApi";
import GenericLoaderComponent from "../Loading/GenericLoaderComponent";
import PDFModalViewer from "../../components/PDFViewerModal/PDFModalViewer";


const OffersDetails = () => {
  const token = localStorage.getItem("Token");
  const navigate = useNavigate();
  useDocumentTitle("Offers Details");
  const { _id } = useParams();
  const [offerData, setOfferData] = useState(null);
  const [isAnyFileImporting, setIsAnyFileImporting] = useState(false);
  const [poId, setPoId] = useState('');
  console.log("Po id :", poId);
  const [isDfmInfoLoading, setIsDfmInfoLoading] = useState(false);
  const [isMaterialDataLoading, setIsMaterialDataLoading] = useState(false);
  const [isAnyUnsavedChanges, setIsAnyUnsavedChange] = useState(false);
  const [rfqOfferAdditionalData, setRfqOfferAdditionalData] = useState('');
  const [pdfModalInfo, setPdfModalInfo] = useState({
    show: false,
    fileName: '',
    pdfUrl: ''
  });


  const { setIsDirty } = useUnsavedChanges();

  useEffect(() => {
    setIsDirty(isAnyUnsavedChanges);
  }, [isAnyUnsavedChanges])


  const [selectedQuote, setSelectedQuote] = useState(null);
  const [supplierList, setSupplierList] = useState([]);
  const [supplierRFQs, setSupplierRFQs] = useState([]);
  const [isDefaultOrganizationAddressExists, setIsDefaultOrganizationAddressExists] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        const addressData = await getOrganizationAddresses();
        if (addressData.status) {
          const defaultAddress = addressData.data.find(address => address.isDefault);
          if (defaultAddress) {
            setIsDefaultOrganizationAddressExists(true);
          }
        }
      } catch (error) {
        console.error("Error fetching organization address:", error);
      }
    })()

  }, []);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [showRfqModal, setShowRfqModal] = useState(false);
  const [rFQtoShow, setRFQToShow] = useState(null);
  const [captchaCallback, setCaptchaCallBack] = useState(() => { });
  const { setSelectedChatRefId, selectedChatRefId, setChatType } =
    useContext(ChatRefContext);
  const [isPOAlreadyExists, setIsPoAlreadyExist] = useState(false);
  const [showDeclineDescription, setShowDeclineDescription] = useState(false);
  const [declinedRFQData, setDeclinedRFQData] = useState({});
  const [purchaseOrder, setPurchaseOrder] = useState({});
  const [isRFQUpdatable, setIsRFQUpdatable] = useState(true);
  const [isPartsNameChanged, setIsPartsNameChanged] = useState(false);
  const [showCaptchaModal, setShowCaptchaModal] = useState(false);
  const [buttonText, setButtonText] = useState('');
  const [selectedRFQForMail, setSelectedRFQForMail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isNewRowCreated, setNewRowCreated] = useState(false);
  const [masterData, setMasterData] = useState({});
  const [isAnySupplierRFQCreated, setIsAnySupplierRFQCreated] = useState(false);
  const [cost, setCost] = useState(0); // Default cost value
  const [unitPrice, setUnitPrice] = useState(null); // Calculated unit price
  const [unitPriceForm, setUnitPriceForm] = useState(null); // Calculated unit price
  const [margin, setMargin] = useState(0); // Margin percentage input by user
  const [showMarginModal, setShowMarginModal] = useState(false);
  const [updatedPrices, setUpdatedPrices] = useState({});
  const [is3DFileOn, setIs3DFileOn] = useState(false); // State for 3D file toggle
  const [is2DFileOn, setIs2DFileOn] = useState(false); // State for 2D file toggle
  const [selectedEmailListForSupplier, setSelectedEmailLIstForSupplier] = useState([]);
  const [showRfqOfferEditProjectName, setShowRfqOfferEditProjectName] = useState(false);

  const [totalAmounts, setTotalAmounts] = useState({
    totalAmount1: 0,
    totalAmount2: 0,
    totalAmount3: 0,
  });
  const [totalAmount, setTotalAmount] = useState(0);
  const [fullMastersData, setFullMastersData] = useState({});
  const [localPrices, setLocalPrices] = useState({
    price1: "",
    price2: "",
    price3: "",
  });
  const [leadTimes, setLeadTimes] = useState({
    leadTime1: "",
    leadTime2: "",
    leadTime3: "",
  });
  const [selectCostSupplier, setSelectCostSupplier] = useState(null);

  const { organizationName } = useInstance();

  const [selectedCost, setSelectedCost] = useState(null);
  const [supplierSelectedCost, setSupplierSelectedCost] = useState(null);
  const [selectedSupplierId, setSelectedSupplierId] = useState(null);
  const [selectedSupplierStatus, setSelectedSupplierStatus] = useState(null);
  const [supplierSelectedCostIndex, setSupplierSelectedCostIndex] = useState(null);

  const [offerPrices, setOfferPrices] = useState({
    offerPrice1: '',
    offerPrice2: '',
    offerPrice3: ''
  });
  const [show3DFile, setShow3DFile] = useState(true);
  const [show2DFile, setShow2DFile] = useState(true);
  const [isAddLineItemModalShow, setIsLineItemModalShow] = useState(false);
  const [isQuoteListModalOpen, setIsQuoteListModalOpen] = useState(false);
  const [allCncMachineData, setAllCncMachineData] = useState(null);
  const [masterThreeDTechnologyData, setMasterThreeDTechnologyData] = useState([]);
  const [isSave, setIsSave] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    if (isSave) {
      setIsSave(false);
      handleUpdateRFQPartData();
    }

  }, [isSave, offerData]);
  const handleAddItemFromQuoteList = (item) => {
    const newData = {
      threeDTechnology: item.threeDTechnology || null,
      threeDMachine: item.threeDMachine || null,
      threeDMaterial: item.threeDMaterial || null,
      threeDPostProcessing: item.threeDPostProcessing || null,
      cncMaterial: item.cncMaterial || null,
      cncTolerance: item.cncTolerance || null,
      cncParkMarking: item.cncParkMarking || null,
      cncReviewMyDesign: item.cncReviewMyDesign || null,
      cncSurfaceFinish: item?.cncSurfaceFinish || null,
      cncHeatTreatment: item?.cncHeatTreatment,
      cncInternalCorner: item?.cncInternalCorner,
      thumbnail: item.thumbnail || null,
      mainPrice1: item.price1 || 0,
      mainPrice2: item.price2 || 0,
      mainPrice3: item.price3 || 0,
      mainPartDataId: item?._id,
    };
    if (is3DFileOn) {
      newData.selectedFile = item.selectedFile || null;
      newData.importedselectedFile = item.selectedFile || null;
    }
    else {
      newData.importedselectedFile = item.selectedFile || null;
    }
    if (is2DFileOn) {
      newData.twoDFile = item.twoDFile || null
      newData.importedtwoDFile = item.twoDFile || null
    }
    else {
      newData.importedtwoDFile = item.twoDFile || null
    };
    setOfferData((offerData) => {
      const newOfferData = {
        ...offerData,
        partsData: [...offerData.partsData, { ...newData }]
      };
      return newOfferData;
    })
    handleQuoteListModalClick();
    handleLineItemModalClick();
    setNewRowCreated(true);
  }
  const [isBatchFileDownloading, setIsBatchFileDownloading] = useState(false);


  const handleBatchClick = async () => {
    setIsLoading(true);
    try {
      const response = await downloadBatchFileSupplier(_id, 'rfq-offer');

      const blob = new Blob([response], { type: 'application/zip' });
      const downloadUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `batch_download_${offerData?.type || ""}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);

    } catch (error) {
      console.log("Error :", error);
      toast.error("Failed to download batch file at the moment");

    } finally {
      setIsLoading(false);
    }

  }
  const handleLineItemModalClick = () => {
    setIsLineItemModalShow((pre) => !pre);
  }
  const handleQuoteListModalClick = () => {
    setIsQuoteListModalOpen((pre) => !pre);
  };
  useEffect(() => {
    setLocalPrices({
      price1: selectedQuote?.price1 ? Number(selectedQuote.price1) : "",
      price2: selectedQuote?.price2 ? Number(selectedQuote.price2) : "",
      price3: selectedQuote?.price3 ? Number(selectedQuote.price3) : "",
    });
    if (selectedQuote) {
      setLeadTimes({
        leadTime1: offerData?.leadTime1 ? Number(offerData.leadTime1) : "",
        leadTime2: offerData?.leadTime2 ? Number(offerData.leadTime2) : "",
        leadTime3: offerData?.leadTime3 ? Number(offerData.leadTime3) : "",
      })
    }
  }, [selectedQuote]);


  useEffect(() => {
    if (isNewRowCreated) {
      const fetchDataforNewRow = async () => {
        try {
          setIsLoading(true);
          let formData = new FormData();
          formData.append("updatedRFQ", JSON.stringify(offerData));

          let updatedRFQResponse = await updateOfferPartsData(formData, token);
          if (updatedRFQResponse?.data?.status) {
            setIsPartsNameChanged(false);
            toast.success("New row created successful");
            fetchData();
          } else {
            toast.error(updatedRFQResponse?.data?.data?.message);
          }

        } catch (error) {
          toast.error("Unable to created new row ");
        } finally {
          setIsLoading(false);
          setNewRowCreated(false);
        }
      }
      fetchDataforNewRow();
    }
  }, [isNewRowCreated]);
  const handleNewRowCreating = () => {
    if (isPOAlreadyExists) {
      toast.error("Po is already created");
      return;
    }
    setOfferData((rfqData) => {
      const newData = {
        ...rfqData,
        partsData: [...rfqData.partsData, { ...defaultPart }]
      };
      return newData;
    })
    setNewRowCreated(true);
  }
  const handleClone = (index) => {
    setOfferData((rfqData) => {
      const newPartsData = rfqData.partsData[index];
      delete newPartsData._id;
      const newData = {
        ...rfqData,
        partsData: [...rfqData.partsData, newPartsData],
      };
      return newData;
    });
    setNewRowCreated(true);
  }

  useEffect(() => {
    (async () => {
      try {
        validateAdmin(token, navigate);
        await fetchData();
      } catch (err) {
        console.log(
          "Error in 83 Offer Details on " +
          moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
          err
        );
        toast.error("Something went wrong while loading the page");
        setIsLoading(false);
      }
    })()
  }, []);

  const handleCloseCaptchaModal = () => {
    setShowCaptchaModal(false);
    setSelectedRFQForMail("");
    setCaptchaCallBack(() => { });
    setButtonText('');
  };

  console.log("OfferData :", offerData);

  const inputRefs = useRef([]);


  const handleMetaDataSave = (index, newData) => {

    console.log("New Data :", newData);
    setOfferData((item) => {
      const newPartData = item?.partsData?.map((item, idx) => {
        if (idx == index) {
          return { ...item, ...newData };
        }
        return item;
      })
      const updatedData = {
        ...item,
        partsData: newPartData
      };
      return updatedData;
    });
    setIsSave(true);
  };

  const handleSendRFQEmail = async (selectedRFQForMail, emails) => {

    try {

      console.log("Selected RFQ For Mail :", selectedRFQForMail);
      console.log("Emails 1:", emails);
      await handleSendRFQMail(selectedRFQForMail, emails);
      await handleUpdateRFQPartData("mail");
      setSelectedRFQForMail("");
    } catch (err) {
      console.log("err", err);
    }
  };


  const showSupplierDrawer = (RefId) => {
    setSelectedChatRefId(RefId);
    setChatType("supplier");
  };

  const onClose = () => {
    setChatType(null);
    setSelectedChatRefId(null);
  };

  const handleUpdateOfferPrice = (id, status) => {
    if (status == "Active Order") {
      setIsRFQUpdatable(false);
    }
    if (status == "Unapproved") {
      setIsRFQUpdatable(false);
    }
    if (status == "Cancelled") {
      setIsRFQUpdatable(false);
    }
    const rfqItem = supplierRFQs.find((item) => item._id === id);
    setRFQToShow(rfqItem);

  }
  const handleDeleteRow = (index) => {
    if (isPOAlreadyExists) {
      toast.error("Po already created");
      return;
    }
    if (offerData.partsData?.length == 1) {
      toast.error("At least one line item is required");
      return;
    }
    else {
      setOfferData((rfq) => {
        return {
          ...rfq,
          partsData: [...rfq.partsData].filter((_, idx) => idx != index)
        };
      });
    }

  };
  const fetchDfmInfo = async (partsData) => {
    console.log("Parts data ::", partsData);
    const ids = partsData?.map((item) => item?.stagingPartsDataId).filter(Boolean);
    setIsDfmInfoLoading(true);
    try {
      const res = await getDFMInfo(ids);
      const dfmData = res?.data;

      const updatedPartsData = partsData.map((part) => {
        const stagingPartsDataId = part?.stagingPartsDataId;
        if (stagingPartsDataId && dfmData[stagingPartsDataId]) {
          return {
            ...part,
            ...(dfmData[stagingPartsDataId]?.data || {}),
          };
        }
        return part;
      });
      setOfferData((pre) => {
        return {
          ...pre,
          partsData: updatedPartsData,
        }
      });



    } catch (err) {
      console.log("error ::", err);
    }
    finally {
      setIsDfmInfoLoading(false);
    }


  };

  const fetchMaterialData = async (type) => {
    if (!type) return;
    try {
      setIsMaterialDataLoading(true);
      const materialListResponse = await getAllMaterialsList(type);
      if (materialListResponse) {
        setFullMastersData(materialListResponse);
      }

    } catch (error) {

    } finally {
      setIsMaterialDataLoading(false);
    }

  };

  const fetchSecondaryData = async (quoteId) => {

    try {
      const quoteDataResponse = await getData([
        {
          modelName: 'quotes',
          fields: ['partsData', 'price1', 'price2', 'price3', 'selectedProcess'],
          "filter": { "_id": quoteId },
        }
      ], 'getdata quote data for offer ');
      if (!quoteDataResponse.success) return;
      const { results } = quoteDataResponse;
      const data = results?.quotes?.[0];
      const type = data?.selectedProcess == 1 ? "CNC" : data?.selectedProcess == 2 ? "3D Printing" : "Both";
      if (data?.selectedProcess == 1) {
        fetchMaterialData(type);
        getAllMachineDataWithPopulation().then(response => setAllCncMachineData(response.data)).catch(console.error);
      }
      else if (data?.selectedProcess == 2) {
        getAllTechnology().then(response => setMasterThreeDTechnologyData(response.data)).catch(console.error);
      }
      setSelectedQuote(data);

      const response = await getOtherRFQOfferData(token, quoteId, 'rfq');
      if (response?.success) {
        const { success, ...data } = response;
        console.log("Setting data ::", data);
        setRfqOfferAdditionalData(data);
      }
    } catch (error) {
      console.error("Error fetching secondary data:", error);
      toast.error("Failed to fetch quote data");
    }
  };
  console.log("is threed on :", is3DFileOn);
  console.log("is twod on :",)
  const fetchData = async () => {
    try {
      setIsLoading(true);
      // const rfqResponse = await fetchRFQById(_id, token);
      const res = await getDataSupplier([
        {
          "modelName": "rfqOfferModel",
          "filter": { "_id": _id },
        },
        {
          "modelName": "supplierRFQOfferModel",
          "filter": {
            "rfqOfferId": _id,
            poCreationDate: { $exists: true, $ne: null }
          },
        },
      ]);
      if (!res.success) return;
      const { results } = res;
      const rfqData = results?.rfqOfferModel?.[0];
      console.log("Data ::", rfqData);
      const poData = results?.supplierRFQOfferModel?.[0]
      // const offerResponse = await fetchOfferById(_id, token);
      console.log("Data :", rfqData);
      console.log("Po data ::", poData);
      setOfferData(rfqData);
      setIs3DFileOn(rfqData.Import3D);
      setIs2DFileOn(rfqData.Import2D);
      setIsPoAlreadyExist(!!poData);
      fetchSecondaryData(rfqData?.quotationId);
      fetchDfmInfo(rfqData.partsData);

      if (!!poData) {
        // setPoId(rfqResponse?.data?.response?.poDetails?._id);
      }
      const totalAmounts = rfqData?.partsData?.reduce(
        (totals, part) => {
          totals.offerPrice1 += part.qty * part.offerPrice1;
          totals.offerPrice2 += part.qty * part.offerPrice2;
          totals.offerPrice3 += part.qty * part.offerPrice3;
          return totals;
        },
        { offerPrice1: 0, offerPrice2: 0, offerPrice3: 0 }
      );

      // Update totals
      setTotalAmounts({
        totalAmount1: totalAmounts.offerPrice1,
        totalAmount2: totalAmounts.offerPrice2,
        totalAmount3: totalAmounts.offerPrice3,
      });


      const supplierRFQResponse = await getSupplierRFQsForRFQ(token, _id);
      if (supplierRFQResponse.status) {
        setSupplierRFQs(supplierRFQResponse.data);
        let supplierRFQForPO = "";
        supplierRFQResponse.data.forEach((item) => {
          if (item.isSelected) {
            supplierRFQForPO = item._id;
          }
        });

        if (supplierRFQForPO.length > 0) {
          let poResponse = await getPOBySupplierRFQId(token, supplierRFQForPO);
          if (poResponse.status) {
            setPurchaseOrder(poResponse.data);
          }
        }
      };
      const supResponse = await getAllSuppliers(token);
      if (supResponse.status) {
        let filteredSupplierData = supResponse.data.filter(
          (item) => item.status == "Active"
        );
        setSupplierList(filteredSupplierData);
      }

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(
        "Error in 187 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
      toast.error("Something went wrong while fetching Offer data.");
    }
  };


  const handleCreatePurchaseOrder = async (rfqSelectedForPO) => {
    try {
      let formData = new FormData();

      formData.append("rfqData", JSON.stringify(rfqSelectedForPO));

      const poResponse = await createPurchaseOrderOffer(formData, token);
      if (poResponse?.data?.status) {
        toast.success(poResponse?.data?.message);
        navigate(
          `/admin/purchase-order-details/${poResponse?.data?.data?._id}`
        );
      } else {
        toast.error(poResponse?.data?.message);
      }
    } catch (err) {
      console.log(
        "Error in 257 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };


  const handleSnapShotUpload = async (e, id, isSnapshotExists) => {
    if (isSnapshotExists) {
      let adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Upload snapshot?',
          content: (
            <>
              <p>Are you sure you want to upload a new snapshot?</p>
              <p style={{ color: 'red', marginTop: 10 }}>
                Warning: This action will permanently replace the existing snapshot. The old snapshot cannot be recovered.
              </p>
            </>
          ),
          okText: 'Yes, Upload',
          cancelText: 'Cancel',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!adminResponse) return;
    }


    const file = e.target.files[0];
    const MAX_FILE_SIZE_MB = 10;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
    if (!file) return;
    if (file.size > MAX_FILE_SIZE_BYTES) {
      toast.error(`File size exceeds ${MAX_FILE_SIZE_MB} MB limit.`);
      return;
    }
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed.");
      return;
    }


    if (!offerData._id) {
      toast.error("Please select a offer to upload snapshot.");
      return;
    }
    const formData = new FormData();
    formData.append("snapshot", file);
    formData.append("item_id", id);
    formData.append("id", offerData._id);
    try {
      setIsLoading(true);

      const response = await uploadPartSnapShotDataOfferRFQ(token, formData);
      if (!response.success) {
        throw new Error();
      }
      const { url } = response;
      setOfferData((pre) => {
        return {
          ...pre,
          partsData: pre.partsData.map((item) => {
            if (item._id == id) {
              return {
                ...item,
                thumbnail: url
              }
            } else {
              return item;
            }
          })
        }
      });




    } catch (error) {
      console.log("Error ::", error);
      toast.error("Unable to upload snapshot at the moment.");
    }
    finally {
      setIsLoading(false);

    }

  }
  const handleDeleteSnapshot = async (id) => {

    let adminResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Delete Snapshot?',
        content: (
          <>
            <p>Are you sure you want to delete this snapshot?</p>
            <p style={{ color: 'red', marginTop: 10 }}>
              Warning: This action will permanently delete the current snapshot and it cannot be recovered.
            </p>
          </>
        ),
        okText: 'Yes, Delete',
        cancelText: 'Cancel',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

    if (!adminResponse) return;


    const data = {
      item_id: id,
      id: offerData?._id,
    }
    try {
      setIsLoading(true);

      const response = await deletePartSnapShotDataOfferRFQ(token, data);
      console.log("response from delte ::", response);
      if (!response.success) {
        throw new Error();
      }
      setOfferData((pre) => {
        return {
          ...pre,
          partsData: pre.partsData.map((item) => {
            if (item._id == id) {
              console.log("setting null ::");
              return {
                ...item,
                thumbnail: ''
              }
            } else {
              return item;
            }
          })
        }
      });

    } catch (error) {
      console.log("Error123 ::", error);
      toast.error("Unable to upload snapshot at the moment.");
    }
    finally {
      setIsLoading(false);

    }

  }

  const handleUpdateRFQPartData = async (TypeSubmit) => {
    if (purchaseOrder._id) {
      toast.error("Purchase order is already created for this offer.");
      return;
    }
    if (offerData.rfqOfferStatus === "cancelled") {
      const adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Change Offer Status',
          content: 'Do you want to move the offer to Inprogress status?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });

      if (!adminResponse) {
        return;
      }
    }
    if (validateQuantity()) {
      toast.error("Quantity should not be zero.");
      return;
    }
    setIsLoading(true);

    try {
      // Activate Offer if required
      if (offerData.rfqOfferStatus === "cancelled") {
        const activationResponse = await activateRFQ(token, offerData._id);
        if (!activationResponse.success) {
          toast.error("Unable to change offer status");
          return;
        }
      }

      // Update admin comments
      await updateRFQAdminComment(token, { id: offerData._id, adminComment: offerData.adminComment });

      // Validate parts data
      // if (!validatePartsName()) {
      //   toast.error("Part name for all line items is a mandatory field.");
      //   return;
      // }



      const totalLeadTime =
        parseFloat(leadTimes?.leadTime1 || 0) +
        parseFloat(leadTimes?.leadTime2 || 0) +
        parseFloat(leadTimes?.leadTime3 || 0);
      // Prepare updated Offer data
      const newRfqData = {
        ...offerData,
        offerPrice: supplierSelectedCost,
        selectedSupplierId: selectedSupplierId,
        supplierSelectedCostIndex: supplierSelectedCostIndex,
        leadTime: totalLeadTime,
        offerPrices,
        totalAmounts,
        leadTimes,
        type: "offer",
        Import3D: is3DFileOn,
        Import2D: is2DFileOn,
      };
      delete newRfqData.rfqOfferStatus;

      const formData = new FormData();
      formData.append("updatedRFQ", JSON.stringify(newRfqData));

      // Update Offer parts data
      const updatedRFQResponse = await updateOfferPartsData(formData, token);
      if (updatedRFQResponse?.data?.status) {
        await fetchData();
        if (TypeSubmit == "manully") {
          toast.success(updatedRFQResponse?.data?.message);
        }
      } else {
        toast.error(updatedRFQResponse?.data?.data?.message);
      }
    } catch (err) {
      console.error("Error in Offer Details", moment().format("DD MMM YYYY hh:mm:ss a"), err);
      toast.error("An unexpected error occurred.");
    } finally {
      setIsLoading(false);
      setIsAnyUnsavedChange(false);
    }
  };


  const handleSelectedFileRemove = async (index, fileType) => {
    let adminResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Confirm Update',
        content: 'Once the file is deleted, it cannot be accessed again. Are you sure you want to update the Offer?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
    if (!adminResponse) {
      return;
    }
    let data = {
      rfqOfferId: offerData._id,
      fileType,
      partIndex: index,
    };

    let response = await deleteFileFromRFQ(data, token);

    if (response.status) {
      const newOfferData = { ...offerData };
      if (fileType == "2D") {
        newOfferData.partsData[index].twoDFile = null;
        setIs2DFileOn(false);
      }
      else {
        newOfferData.partsData[index].selectedFile = null;
        newOfferData.partsData[index].thumbnail = null;
        newOfferData.partsData[index].gltfPlainFileUrl = null;
        newOfferData.partsData[index].gltfColoredFileUrl = null;
        newOfferData.partsData[index].stagingPartsDataId = null;
        setIs3DFileOn(false);
      }

      setOfferData(newOfferData);
      if (fileType == '3D') {
        setIs3DFileOn(false);
      }
      else {
        setIs2DFileOn(false);
      }
      toast.success("File deleted successfully");
    } else {
      toast.error("Something went wrong while uploading files.");
    }
  };

  const handleFileUpload = async (event, index, fileType) => {
    const file = event.target.files[0];
    try {
      setIsLoading(true);
      let formData = new FormData();
      formData.append("rfqOfferId", offerData?._id);
      formData.append("fileType", fileType);
      console.log(fileType);
      if (fileType == "2D") {
        formData.append("twoDFile", file);
      } else {
        // starting quaoar flow
        const isFileNameValid = isValidFileName(file?.name || file?.path);
        console.log("is Valid ::", isFileNameValid);
        if (isFileNameValid) {
          const response = await processFileWithAnalysis(file, (queueStatus) => {
            console.log("Quotation status ::", queueStatus);
          });
          const dataReceivedFromResponse = response.data?.result;
          const analysisData = {
            s3QrFileUrl: dataReceivedFromResponse?.filesS3Data || null,
            jsonFileUrl: dataReceivedFromResponse?.quaoarResponseFiles?.[0]?.json || null,
            thumbnail: dataReceivedFromResponse?.quaoarResponseFiles?.[1]?.png || null,
            gltfPlainFileUrl: dataReceivedFromResponse?.quaoarResponseFiles?.[2]?.glb?.[0] || null,
            gltfColoredFileUrl: dataReceivedFromResponse?.quaoarResponseFiles?.[2]?.glb?.[1] || null,
            stagingPartsData: dataReceivedFromResponse?.stagingPartResponse || "",
          };
          console.log("Data ::", analysisData);
          formData.append("analysisData", JSON.stringify(analysisData));
        }

        formData.append("selectedFile", file);
      }
      formData.append("partIndex", index);

      let response = await uploadFileToRFQ(formData, token);

      if (response.status) {
        const newOfferData = { ...offerData };
        if (fileType == "2D") {
          newOfferData.partsData[index].twoDFile = response?.data?.partsData[index]?.twoDFile;
          setIs2DFileOn(response?.data?.Import2D);
        }
        else {
          newOfferData.partsData[index].selectedFile = response?.data?.partsData[index]?.selectedFile;
          newOfferData.partsData[index].thumbnail = response?.data?.partsData[index]?.thumbnail;
          newOfferData.partsData[index].gltfPlainFileUrl = response?.data?.partsData[index]?.gltfPlainFileUrl;
          newOfferData.partsData[index].gltfColoredFileUrl = response?.data?.partsData[index]?.gltfColoredFileUrl;
          newOfferData.partsData[index].stagingPartsDataId = response?.data?.partsData[index]?.stagingPartsDataId;
          setIs3DFileOn(response?.data?.Import3D);
        }
        setOfferData(newOfferData);
        setIsSave(true);
        // toast.success("File uploaded successfully");
      } else {
        toast.error("Something went wrong while uploading files.");
      }
    } catch (err) {
      console.log(
        "Error in 316 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
    finally {
      setIsLoading(false);
    }
  };

  function ErrorCheckHOF(callback) {
    return (...arg) => {
      if (isAnyUnsavedChanges) {
        toast.error("There are unsaved changes. Please save them to continue.");
        return;
      }
      callback(...arg);
    }

  };

  const handleSupplierOfferSelectedMethodChange = (selectedOfferMethod, index) => {
    setSupplierRFQs((pre) => {
      return pre.map((item, idx) => idx == index ? { ...item, selectedOfferMethod } : item)
    })
  };

  const handleRFQItemQtyChange = (e, index) => {
    setIsAnyUnsavedChange(true);
    const newQty = e.target.value; // Get the new quantity from input
    const isEmpty = newQty === "";
    console.log("New Qty :", newQty);
    console.log("Is Empty :", isEmpty);
    const isNaturalNumber = /^[1-9][0-9]*$/.test(newQty);
    if (!isEmpty && !isNaturalNumber) {
      return;
    }

    // Update the quantity and calculate the appropriate LineTotal
    setOfferData((prevData) => {
      const updatedPartsData = [...prevData.partsData];
      updatedPartsData[index].qty = newQty;

      // Default offerPrice to 0 if not available (undefined or null)
      const offerPrice1 = updatedPartsData[index].offerPrice1 || 0;
      const offerPrice2 = updatedPartsData[index].offerPrice2 || 0;
      const offerPrice3 = updatedPartsData[index].offerPrice3 || 0;

      // Update LineTotal based on the offerPrice values
      updatedPartsData[index].LineTotal1 = (offerPrice1 * newQty).toFixed(2);
      updatedPartsData[index].LineTotal2 = (offerPrice2 * newQty).toFixed(2);
      updatedPartsData[index].LineTotal3 = (offerPrice3 * newQty).toFixed(2);

      // Calculate SubTotal1, SubTotal2, and SubTotal3
      const subTotal1 = updatedPartsData.reduce((total, part) => {
        const offerPrice1 = parseFloat(part.offerPrice1) || 0;
        const qty = part.qty || 0;
        return total + offerPrice1 * qty;
      }, 0).toFixed(2);

      const subTotal2 = updatedPartsData.reduce((total, part) => {
        const offerPrice2 = parseFloat(part.offerPrice2) || 0;
        const qty = part.qty || 0;
        return total + offerPrice2 * qty;
      }, 0).toFixed(2);

      const subTotal3 = updatedPartsData.reduce((total, part) => {
        const offerPrice3 = parseFloat(part.offerPrice3) || 0;
        const qty = part.qty || 0;
        return total + offerPrice3 * qty;
      }, 0).toFixed(2);

      const totalAmounts = updatedPartsData.reduce(
        (totals, part) => {
          totals.offerPrice1 += part.qty * part.offerPrice1;
          totals.offerPrice2 += part.qty * part.offerPrice2;
          totals.offerPrice3 += part.qty * part.offerPrice3;
          return totals;
        },
        { offerPrice1: 0, offerPrice2: 0, offerPrice3: 0 }
      );

      console.log("Total Amount 2 :", totalAmounts);

      // Update totals
      setTotalAmounts({
        totalAmount1: totalAmounts.offerPrice1,
        totalAmount2: totalAmounts.offerPrice2,
        totalAmount3: totalAmounts.offerPrice3,
      });

      return {
        ...prevData,
        ...prevData.partsData,
        partsData: updatedPartsData,
        SubTotal1: subTotal1,  // Add SubTotal1 outside partsData
        SubTotal2: subTotal2,  // Add SubTotal2 outside partsData
        SubTotal3: subTotal3,  // Add SubTotal3 outside partsDat
      };
    });
  };


  const handleRFQItemUnitPriceChange = (newprice, event, i) => {
    let localRFQPartsData = offerData;
    // localRFQPartsData.partsData[i].unitPrice = event.target.value;
    localRFQPartsData.partsData.map(part => part.unitPrice = newprice)
    setOfferData({ ...localRFQPartsData });
  };

  const handleCostSelect = (e) => {
    const selectedValue = (e.target.value); // selected cost value from dropdown
    setSelectedCost(selectedValue); // Set the selected cost
  };

  const handleSupplierCostSelect = (value, supplierId, status, index) => {
    console.log("index", index);
    setSupplierSelectedCost(value); // Set the selected cost
    setSelectedSupplierId(supplierId);
    setSelectedSupplierStatus(status);
    setSupplierSelectedCostIndex(index); // Set the selected index
  };


  const handleCalculatePricing = () => {
    setShowMarginModal(true);

  };

  const handleMarginModalClose = () => {
    setShowMarginModal(false);
  };

  const handleMarginChange = (e) => {
    let value = e.target.value;
    if (value > 100) value = 100;
    if (value < 0) value = 0;
    setMargin(value); // Set the margin
  };

  const calculateOfferPrice = (cost) => {
    if (!cost || margin < 0) return 0; // Avoid calculation if invalid data

    const price = parseFloat(cost); // Convert cost to number
    const marginAmount = (price * margin) / 100; // Calculate margin amount
    console.log("Price :", price - marginAmount);
    return price - marginAmount; // Add margin to cost
  };

  const marginCalculator = (cost) => {
    return cost - (cost * margin) / 100;
  };

  // const handleSetPrice = () => {
  //   const newPrice = marginCalculator(unitPrice);
  //   // setUnitPrice(newPrice);
  //   setUnitPriceForm(newPrice);

  //   setOfferData((prev) =>
  //     prev.partsData.map(item => item.unitPrice = newPrice)
  //   )
  //   setSupplierRFQs((prev) =>
  //     prev?.map((item) => {
  //       if (item._id === selectedSupplierId) {
  //         const totalAmount = item.partsData.reduce(
  //           (sum, part) => sum + part.qty * newPrice,
  //           0
  //         );

  //         setTotalAmount(totalAmount);
  //         return {
  //           ...item,
  //           offerPrice: totalAmount,
  //         };
  //       }



  //       return item;
  //     })
  //   );

  //   // Handle unit price and close modal
  //   handleRFQItemUnitPriceChange(newPrice);
  //   setShowMarginModal(false); // Close modal after all updates
  // };


  const handleSetPrice = () => {
    if (selectedCost === null || margin < 0) return; // Validate inputs
    // Clone the state to avoid direct mutation
    const updatedPrices = { ...offerPrices };

    // Calculate the new offer price based on the margin
    const calculatedPrice = parseFloat(calculateCP(selectedCost, margin)).toFixed(2);

    // Map the selected cost to the corresponding offer price key
    const priceMapping = {
      [localPrices.price1]: "offerPrice1",
      [localPrices.price2]: "offerPrice2",
      [localPrices.price3]: "offerPrice3",
    };

    const priceKey = priceMapping[selectedCost];
    if (priceKey) {
      updatedPrices[priceKey] = calculatedPrice;
    }

    // Update the offer prices state
    setOfferPrices(updatedPrices);

    // Update partsData in offerData with updatedPrices
    const updatedPartsData = offerData.partsData.map((part) => ({
      ...part,
      offerPrice1: parseFloat(updatedPrices.offerPrice1 || 0),
      offerPrice2: parseFloat(updatedPrices.offerPrice2 || 0),
      offerPrice3: parseFloat(updatedPrices.offerPrice3 || 0),
    }));

    // Update offerData state with updated partsData
    const updatedOfferData = {
      ...offerData,
      partsData: updatedPartsData,
    };

    // Update the state of offerData
    setOfferData(updatedOfferData);

    // Calculate total amounts dynamically
    const totalAmounts = updatedPartsData.reduce(
      (totals, part) => {
        totals.offerPrice1 += part.qty * part.offerPrice1;
        totals.offerPrice2 += part.qty * part.offerPrice2;
        totals.offerPrice3 += part.qty * part.offerPrice3;
        return totals;
      },
      { offerPrice1: 0, offerPrice2: 0, offerPrice3: 0 }
    );

    // Update totals
    setTotalAmounts({
      totalAmount1: totalAmounts.offerPrice1,
      totalAmount2: totalAmounts.offerPrice2,
      totalAmount3: totalAmounts.offerPrice3,
    });
  };

  useEffect(() => {
    (async () => {
      const res = await getDataSupplier();
    })()

  }, [])

  const handleRFQItemDescChange = (event, i) => {
    setIsAnyUnsavedChange(true);
    let localRFQPartsData = offerData;
    localRFQPartsData.partsData[i].description = event.target.value;
    setOfferData({ ...localRFQPartsData });
  };

  const handleOfferLeadTimeChange = (event) => {
    setIsAnyUnsavedChange(true);
    const val = event.target.value;
    const isEmpty = val === "";
    const isNaturalNumber = /^[1-9][0-9]*$/.test(val);
    if (!isEmpty && !isNaturalNumber) {
      return;
    }
    setIsAnyUnsavedChange(true);
    const { name, value } = event.target;
    setLeadTimes((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleAddSupplier = async () => {
    if (offerData.rfqOfferStatus == 'cancelled') {
      toast.error("Offer cancelled cannot add new suppliers");
      return;
    }
    if (isPOAlreadyExists) {
      toast.error("Purchase order is already created for this quotation.");
      return;
    }
    if (!selectedSupplier) {
      toast.error("Select a valid supplier");
      return;
    }
    const isSupplierSelected = supplierRFQs.some(
      (rfq) => rfq.supplierId._id == selectedSupplier._id
    );
    if (isSupplierSelected) {
      toast.error("Supplier is already selected.");
      return;
    }
    handleCreateSupplierRFQ();
  };

  const validateQuantity = () => {
    const partsData = offerData.partsData;
    return partsData.some((item) => Number(item.qty) <= 0)
  };
  const handleCreateSupplierRFQ = async () => {
    setIsLoading(true);
    try {
      let data = {
        supplierId: selectedSupplier._id,
        rfqOfferId: _id,
        type: 'offer'
      };
      const supplierRFQResponse = await createSupplierRFQ(token, data);
      console.log("Supplier Response :", supplierRFQResponse);
      if (supplierRFQResponse?.status) {
        toast.success("Supplier added successfully");
        setSupplierRFQs([...supplierRFQs, supplierRFQResponse.data]);
        if (offerData.rfqOfferStatus === 'cancelled') {
          setOfferData({ ...offerData, rfqOfferStatus: 'in-progress' });
        }
      }
    } catch (err) {
      console.log(
        "Error in 371 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateRfQClick = async () => {
    try {
      let adminResponse = confirm(
        'Are you sure you want to update the Offer information. Once updated, the Offer will be moved to "Under review" status.'
      );
      if (adminResponse) {
        // let isRFQDataValid = validateRFQData();
        // if (isRFQDataValid) {
        let dataToSend = {
          partsData: rFQtoShow.partsData,
          price: rFQtoShow.price,
          offerPrice1: rFQtoShow.offerPrice1,
          offerPrice2: rFQtoShow.offerPrice2,
          offerPrice3: rFQtoShow.offerPrice3,
          _id: rFQtoShow._id,
        };
        let updatedRFQResponse = await handleUpdateRfQ(
          { ...dataToSend },
          token
        );
        let localRFQForQuotation = [...supplierRFQs];
        for (let i = 0; i < localRFQForQuotation.length; i++) {
          if (
            localRFQForQuotation[i]._id == updatedRFQResponse.data.data._id
          ) {
            localRFQForQuotation[i] = updatedRFQResponse.data.data;
            break;
          }
        }
        if (updatedRFQResponse.data.status) {
          toast.success(updatedRFQResponse.data.message);
          setSupplierRFQs(localRFQForQuotation);
          setShowRfqModal(false);
        } else {
          toast.error(updatedRFQResponse.data.data.message);
        }
      } else {
        toast.error("Item price and lead time are required fields.");
      }
      // }
    } catch (err) {
      console.log(
        "Error in 405 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleDeleteRFQ = async (id) => {
    try {
      let adminResponse1 = true;
      if (supplierRFQs.length == 1) {
        adminResponse1 = await new Promise((resolve) => {
          AntModal.confirm({
            title: 'Delete Supplier?',
            content: 'If you proceed with deleting this supplier, the associated Offer will no longer be valid. Are you sure you want to continue?',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        });
      }
      if (adminResponse1) {

        const deleteResponse = await deleteRFQ(id, token);
        if (deleteResponse.data.status) {
          let localRFQForQuotation = [...supplierRFQs];
          localRFQForQuotation = localRFQForQuotation.filter(
            (item) => item._id != id
          );
          setSupplierRFQs([...localRFQForQuotation]);
          toast.success('Offer deleted succesfully');
        } else {
          toast.error(deleteResponse.data.message);
        }
      }
    } catch (err) {
      console.log("Error in delete rfq", err.message);
    }
  };


  const validateRFQData = () => {
    let isDataValid = true;
    let isPriceAvailable = false;
    for (let i = 0; i < rFQtoShow.partsData.length; i++) {
      if (rFQtoShow.partsData[i].price > 0) {
        isPriceAvailable = true;
        break;
      }
    }

    if (isPriceAvailable) {
      isDataValid = true;
    } else {
      isDataValid = false;
    }

    if (!rFQtoShow.leadTime) {
      isDataValid = false;
    }
    return isDataValid;
  };

  const handleRFQItemPriceChange = (event, index) => {
    setIsAnyUnsavedChange(true);
    const { name, value } = event.target;

    // Allow decimal points and numbers
    if (!/^\d*\.?\d*$/.test(value) && value !== '') return;

    // Handle the case when only a decimal point is entered
    if (value === '.') {
      let localOfferPartsData = [...offerData.partsData];
      localOfferPartsData[index][name] = '0.';

      setOfferPrices(prev => ({
        ...prev,
        [name]: '0.'
      }));

      setOfferData(prev => ({
        ...prev,
        partsData: localOfferPartsData
      }));
      return;
    }

    const updatedValue = value === '' ? '' : parseFloat(value);

    setOfferPrices(prevOfferPrices => ({
      ...prevOfferPrices,
      [name]: value // Keep the string value to maintain decimal point
    }));

    let localOfferPartsData = [...offerData.partsData];
    localOfferPartsData[index][name] = value; // Keep the string value

    setOfferData(prev => ({
      ...prev,
      partsData: localOfferPartsData
    }));
    const totalAmounts = localOfferPartsData.reduce(
      (totals, part) => {
        totals.offerPrice1 += part.qty * part.offerPrice1;
        totals.offerPrice2 += part.qty * part.offerPrice2;
        totals.offerPrice3 += part.qty * part.offerPrice3;
        return totals;
      },
      { offerPrice1: 0, offerPrice2: 0, offerPrice3: 0 }
    );

    // Update totals
    setTotalAmounts({
      totalAmount1: totalAmounts.offerPrice1,
      totalAmount2: totalAmounts.offerPrice2,
      totalAmount3: totalAmounts.offerPrice3,
    });
  };

  const handleSendRFQMail = async (rFQId, emails) => {
    console.log("Selected RFQ For Mail :", rFQId);
    console.log("Emails 1:", emails);
    try {
      let adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Send Offer to Supplier',
          content: 'Are you sure you want to send this Offer to supplier?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (adminResponse) {
        const selectedMethod = supplierRFQs.find((item) => item?._id == rFQId)?.selectedOfferMethod;

        if (!selectedMethod) {
          toast.error("Please select the offer method for this supplier RFQ.");
          return;
        }
        let leadTime;
        if (selectedMethod == 1) {
          leadTime = leadTimes['leadTime1']
        }
        else if (selectedMethod == 2) {
          leadTime = leadTimes['leadTime2']
        }
        else if (selectedMethod == 3) {
          leadTime = leadTimes['leadTime3']
        }
        let response = await sendOfferoSupplier(rFQId, selectedMethod, leadTime, token, emails);
        let localRFQForQuotation = [...supplierRFQs];
        for (let i = 0; i < supplierRFQs.length; i++) {
          if (localRFQForQuotation[i]._id == response.data._id) {
            localRFQForQuotation[i] = response.data;
          }
        }
        setSupplierRFQs([...localRFQForQuotation]);
        if (response.status) {
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      }
    } catch (err) {
      console.log(
        "Error in 505 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleMarkAsSentRFQ = async (supplierRfqOfferId, selectedOfferMethod) => {

    try {
      let adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Mark Offer as Sent',
          content: 'Are you sure you want to mark this Offer as sent?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      let leadTime;
      if (selectedOfferMethod == 1) {
        leadTime = leadTimes['leadTime1']
      }
      else if (selectedOfferMethod == 2) {
        leadTime = leadTimes['leadTime2']
      }
      else if (selectedOfferMethod == 3) {
        leadTime = leadTimes['leadTime3']
      }
      console.log("LeadTime Going :", leadTime);
      if (adminResponse) {
        let response = await markRFQAsSent(supplierRfqOfferId, token, selectedOfferMethod, leadTime);
        let localRFQForQuotation = [...supplierRFQs];
        for (let i = 0; i < supplierRFQs.length; i++) {
          if (localRFQForQuotation[i]._id == response.data._id) {
            localRFQForQuotation[i] = response.data;
          }
        }
        setSupplierRFQs([...localRFQForQuotation]);
        if (response.status) {
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      }
    } catch (err) {
      console.log(
        "Error in 505 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleSwitchClick = async (offerData) => {
    try {


      let isOrderAlreadyCreated;
      supplierRFQs.forEach((item) => {
        if (item.isSelected) {
          isOrderAlreadyCreated = true;
        }
      });

      if (isOrderAlreadyCreated) {
        toast.error("Purchase order for this Offer is already created.");
        return;
      }
      setIsDirty(false);

      if (rfqOfferAdditionalData?.poCreated) {
        toast.error("Purchase order already created from linked rfq");
        return;
      }
      if (offerData?.isOfferDeclined) {
        toast.error("Cannot create purchase order with declined offer");
        return;
      }

      if (rfqOfferAdditionalData?.rfqOffer?._id) {
        let adminResponse = await new Promise((resolve) => {
          AntModal.confirm({
            title: 'Confirm Supplier Selection',
            content: `A linked rfq is also created for this quotation. Proceeding will cancel the existing rfq and its related supplier rfqs. Are you sure you want to continue and create a Draft Purchase Order for ${offerData?.supplierId?.companyName}?`,
            okText: 'Yes, Proceed',
            cancelText: 'Cancel',
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        });

        if (!adminResponse) {
          return;
        }


      }
      else {
        let adminResponse = await new Promise((resolve) => {
          AntModal.confirm({
            title: 'Confirm Supplier Selection',
            content: `Are you sure you want to select ${offerData?.supplierId?.companyName}? A Draft Purchase Order will be created on confirmation.`,
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        });
        if (!adminResponse) {
          return;
        }
      }
      handleCreatePurchaseOrder(offerData);
    } catch (err) {
      console.log(
        "Error in 523 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleCancelRFQ = async () => {

    if (isPOAlreadyExists) {
      toast.error("Purchase order Is Already Created Unable to Cancel");
      return;
    }
    try {
      if (offerData.rfqOfferStatus == "cancelled") {
        toast.error("The offer is already cancelled");
        return;
      }

      const adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Delete Offer and Supplier RFQs',
          content: `Are you sure you want to delete for ${offerData.projectName}? Note: All supplier RFQs will get deleted for this project as well.`,
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!adminResponse) {
        return;
      }
      const cancelResponse = await cancelRFQ(_id, token);
      if (cancelResponse.status) {
        navigate(`/admin/admin-quote/${offerData?.quotationId}`);
      }
    } catch (err) {
      console.log(
        "Error in 582 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleShowDeclinedDetails = (itemId) => {
    let declinedRFQData = supplierRFQs.filter((item) => item._id == itemId);
    setDeclinedRFQData(declinedRFQData[0]);
    setShowDeclineDescription(true);
  };

  const handleDeclineModalClose = () => {
    setShowDeclineDescription(false);
  };

  const handle3DFileChange = async (checked) => {
    if (purchaseOrder._id) {
      toast.error("Purchase order is already created for this offer.");
      return;
    }
    const newState = checked ? true : false;
    if (newState) {
      const confirmProceed = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Import 3D Files',
          content: (
            <>
              <p>All 3D files associated with the customer quotation will be imported directly.</p>
              <p style={{ fontWeight: 'bold', marginTop: 8 }}>
                Note: In the future, if any 3D file mismatches the customer quotation, the toggle to view the imported 3D file will be disabled for that entry.
              </p>
            </>
          ),
          okText: 'Proceed',
          cancelText: 'Cancel',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });

      if (!confirmProceed) return;
    }
    setIsAnyUnsavedChange(true);
    setIs3DFileOn(newState);
    if (newState) {
      setIsAnyFileImporting(true);
      const response = await getQuotePartsDataById(offerData?.quotationId);
      if (!response?.success) {
        toast.error("Failed to fetch quote parts data");
        return;
      };
      const quotePartsData = response?.data?.partsData;
      const updatedPartsData = offerData.partsData.map(part => {
        if (quotePartsData.some((quotePart) => quotePart?._id == part?.mainPartDataId)) {
          const quotePartItem = quotePartsData.find((quotePart) => quotePart?._id == part?.mainPartDataId);
          const updatedPart = {
            ...part,
            selectedFile: quotePartItem?.selectedFile,
            thumbnail: quotePartItem?.thumbnail,
          };
          return updatedPart;
        };
        return part;
      });
      setOfferData(prevState => ({
        ...prevState,
        partsData: updatedPartsData,
        Import3D: true,
      }));
      setIsAnyFileImporting(false);
    }
    else {
      const updatedPartsData = offerData.partsData.map(part => {
        return {
          ...part,
          selectedFile: null,
          thumbnail: null,

        };
      });
      setOfferData(prevState => ({
        ...prevState,
        partsData: updatedPartsData,
        Import3D: false,
      }));
    }
    setIsSave(true);
  };

  const handle2DFileChange = async (checked) => {
    if (purchaseOrder._id) {
      toast.error("Purchase order is already created for this offer.");
      return;
    }
    const newState = checked ? true : false;
    if (newState) {
      const confirmImport2D = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Import 2D Files',
          content: (
            <>
              <p>All 2D files associated with the customer quotation will be imported directly.</p>
              <p style={{ fontWeight: 'bold', marginTop: 8 }}>
                Note: In the future, if any 2D file mismatches the customer quotation, the toggle to view the imported 2D file will be disabled for that entry.
              </p>
            </>
          ),
          okText: 'Proceed',
          cancelText: 'Cancel',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });

      if (!confirmImport2D) return;

    }
    setIsAnyUnsavedChange(true);
    setIs2DFileOn(newState);
    if (newState) {
      setIsAnyFileImporting(true);
      const response = await getQuotePartsDataById(offerData?.quotationId);
      if (!response?.success) {
        toast.error("Failed to fetch quote parts data");
        return;
      };
      const quotePartsData = response?.data?.partsData;
      const updatedPartsData = offerData.partsData.map(part => {
        if (quotePartsData.some((quotePart) => quotePart?._id == part?.mainPartDataId)) {
          const quotePartItem = quotePartsData.find((quotePart) => quotePart?._id == part?.mainPartDataId);
          const updatedPart = {
            ...part, twoDFile: quotePartItem?.twoDFile
          };
          return updatedPart;
        };
        return part;
      });
      setOfferData(prevState => ({
        ...prevState,
        partsData: updatedPartsData,
        Import2D: true,
      }));
      setIsAnyFileImporting(false);

    }
    else {
      const updatedPartsData = offerData.partsData.map(part => {
        return {
          ...part,
          twoDFile: null,
        };
      });
      setOfferData(prevState => ({
        ...prevState,
        partsData: updatedPartsData,
        Import2D: false,
      }));
    }
    setIsSave(true);
  };

  const handleSetMargin = () => {
    if (purchaseOrder._id) {
      toast.error("Purchase order is already created for this offer.");
      return;
    }

    if (!selectedCost) {
      toast.error("Please select a valid cost !");
      return;
    }

    if (margin < 0) {
      toast.error("Margin cannot be negative!");
      return;
    }

    const costMapping = {
      "Cost-1": "mainPrice1",
      "Cost-2": "mainPrice2",
      "Cost-3": "mainPrice3",
    };

    const selectedCostKey = costMapping[selectedCost];
    if (!selectedCostKey) return; // Ensure a valid cost key is selected

    const updatedPartsData = offerData?.partsData?.map((part) => {
      // Calculate the offer price for the current part based on the margin
      const selectedPrice = parseFloat(part[selectedCostKey] || 0);
      const calculatedOfferPrice = parseFloat(calculateCP(selectedPrice, margin)).toFixed(2);

      console.log("Calculated Price :", calculatedOfferPrice);

      // Calculate the LineTotal
      const offerPriceKey = `offerPrice${selectedCost.slice(-1)}`;
      const lineTotalKey = `LineTotal${selectedCost.slice(-1)}`;
      const qty = part.qty || 0;
      const calculatedLineTotal = (qty * calculatedOfferPrice).toFixed(2);

      // Add the offerPrice and LineTotal fields dynamically
      return {
        ...part,
        [offerPriceKey]: calculatedOfferPrice,
        [lineTotalKey]: calculatedLineTotal,
      };
    });

    // Calculate SubTotal1 (sum of offerPrice1 * Qty)
    const subTotal1 = updatedPartsData.reduce((total, part) => {
      const offerPrice1 = parseFloat(part.offerPrice1) || 0;
      const qty = part.qty || 0;
      return total + offerPrice1 * qty;
    }, 0).toFixed(2); // Assuming you want it as a string with 2 decimal places

    // Calculate SubTotal2 (sum of offerPrice2 * Qty)
    const subTotal2 = updatedPartsData.reduce((total, part) => {
      const offerPrice2 = parseFloat(part.offerPrice2) || 0;
      const qty = part.qty || 0;
      return total + offerPrice2 * qty;
    }, 0).toFixed(2);

    // Calculate SubTotal3 (sum of offerPrice3 * Qty)
    const subTotal3 = updatedPartsData.reduce((total, part) => {
      const offerPrice3 = parseFloat(part.offerPrice3) || 0;
      const qty = part.qty || 0;
      return total + offerPrice3 * qty;
    }, 0).toFixed(2);

    // Update offerData with the calculated SubTotal1, SubTotal2, and SubTotal3
    const updatedOfferData = {
      ...offerData,
      ...offerData.partsData,
      partsData: updatedPartsData,
      SubTotal1: subTotal1,  // Add SubTotal1 outside partsData
      SubTotal2: subTotal2,  // Add SubTotal2 outside partsData
      SubTotal3: subTotal3,  // Add SubTotal3 outside partsDat
    }

    setOfferData(updatedOfferData);

    const totalAmounts = updatedPartsData.reduce(
      (totals, part) => {
        totals.offerPrice1 += part.qty * part.offerPrice1;
        totals.offerPrice2 += part.qty * part.offerPrice2;
        totals.offerPrice3 += part.qty * part.offerPrice3;
        return totals;
      },
      { offerPrice1: 0, offerPrice2: 0, offerPrice3: 0 }
    );

    // Update totals
    setTotalAmounts({
      totalAmount1: totalAmounts.offerPrice1,
      totalAmount2: totalAmounts.offerPrice2,
      totalAmount3: totalAmounts.offerPrice3,
    });
  };
  const handleAddManualClick = () => {
    handleLineItemModalClick();
    handleNewRowCreating();
  }
  const handleAddFromQuoteClick = () => {
    setIsQuoteListModalOpen(true);
  }


  const handleProjectNameEdit = async (projectName) => {

    setIsLoading(true);

    try {
      setShowRfqOfferEditProjectName(false);
      const data = {
        _id: offerData._id,
        projectName: projectName,
      };
      const res = await updateOfferAndRFQProjectName(token, data);
      console.log("Response from update project name :", res);
      if (res.success) {
        toast.success("Project name updated successfully");
        setOfferData((prevData) => ({
          ...prevData,
          projectName: projectName,
        }));
      };
    } catch (error) {
      toast.error("Failed to update project name");
      console.error("Error updating project name:", error);
    } finally {
      setIsLoading(false);
    }
  }




  return (
    <div
      className="admin-container"
      style={{
        width: "100%",
        overflowX: "auto",
        backgroundColor: "#f4e6dd",
        minHeight: "100vh",
      }}
    >
      {isAnyUnsavedChanges ? <BackButtonWarning
        warning={'"Are you sure you want to go back? There are unsaved changes."'} /> : null}
      {/* {isLoading ? <Loading /> : ""} */}
      <GenericLoaderComponent
        isLoading={isLoading}
      />
      <Sidebar />
      {isAnyFileImporting ? <FileImportModal
      /> : null}
      <Modal
        style={{ width: "300px", margin: "auto", left: "50%", top: "50%", transform: "translate(-50%,-50%)" }}
        size="sm"
        dialogClassName="qoute-version-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showMarginModal}
        onHide={handleMarginModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: "15px" }}>
            Enter Margin Percentage
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="issue-description-div">
            <Form>
              <Form.Group controlId="marginInput">
                <Form.Label>Margin Percentage:</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter margin %"
                  value={margin}
                  onChange={handleMarginChange}
                />
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="req-quote-btn" onClick={handleSetPrice}>
            Set Unit Price
          </Button>
          <Button className="req-quote-btn" variant="secondary" onClick={handleMarginModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={isAddLineItemModalShow} onHide={handleLineItemModalClick} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select an Option</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Would you like to add manually or add from the quote?</p>
        </Modal.Body>
        <Modal.Footer >
          <Button variant="secondary" onClick={() => handleAddManualClick()}>Add Manually</Button>
          <Button variant="secondary" onClick={() => handleAddFromQuoteClick()}>Add from Quote</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={isQuoteListModalOpen} onHide={handleQuoteListModalClick} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Table Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Snapshot</th>
                <th>3D File</th>
                <th>2D File</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                selectedQuote?.partsData.map((item) => {
                  return <tr>
                    <td>
                      {
                        item?.thumbnail && item?.selectedFile ? <img className="h-20" src={item?.thumbnail} /> : <p>No preview available</p>
                      }
                    </td>
                    <td>{
                      item?.selectedFile?.originalname ? <FileName
                        fileName={item?.selectedFile?.originalname}
                      /> : 'No filename available'
                    }</td>
                    <td>{item?.twoDFile?.originalname ? <p className="truncate">{item?.twoDFile?.originalname.slice(0, 25)}</p> : 'No filename available'}</td>
                    <td>
                      <Button className="!bg-complementaryPrimaryColor border-complementaryPrimaryColor" onClick={() => handleAddItemFromQuoteList(item)} size="sm">Add</Button>
                    </td>
                  </tr>
                })
              }


            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleQuoteListModalClick}>Close</Button>
        </Modal.Footer>
      </Modal>
      <CaptchaModal
        showModal={showCaptchaModal}
        handleClose={handleCloseCaptchaModal}
        handleSendEmail={() => captchaCallback?.()}
        buttonText={buttonText}
      />
      <PDFModalViewer
        show={pdfModalInfo.show}
        fileName={pdfModalInfo.fileName}
        pdfUrl={pdfModalInfo.pdfUrl}
        handleClose={() => {
          setPdfModalInfo({
            show: false, fileName: "", pdfUrl: ""
          });
        }
        }
      />
      <EmailModal
        show={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSubmit={(email) => {
          console.log("Selected/Entered Email:", email);
          setShowCaptchaModal(true);
          setCaptchaCallBack(() => () => handleSendRFQEmail(selectedRFQForMail, email));
          setIsModalVisible(false);
        }}
        buttonText="Send"
        category="Offer"
        emailList={selectedEmailListForSupplier}
      />

      <Modal
        size="sm"
        dialogClassName="qoute-version-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showDeclineDescription}
        onHide={handleDeclineModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ fontSize: "15px" }}
          >
            Offer Decline Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="issue-description-div">
            <div>
              <h5>Reason to decline : </h5>
              <p>{declinedRFQData.declineReason}</p>
              <h5>Description : </h5>
              <p>{declinedRFQData.declineDescription}</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="req-quote-btn" onClick={handleDeclineModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <RFQOfferEditProjectName
        show={showRfqOfferEditProjectName}
        currentName={offerData?.projectName}
        onCancel={() => { setShowRfqOfferEditProjectName(false); }}
        onSave={handleProjectNameEdit}

      />
      <span style={{ width: "100%" }}>
        <div className="center-heading">
          <h1 className="text-2xl font-bold mt-3">Offers Details</h1>
          <div className="right-container">
            <h5 className="text-left !mb-2 flex items-center gap-x-2 ">
              {offerData?.projectName ?
                <Fragment>     <span> Project Name : {offerData?.projectName}{" "}  {offerData?.rfqOfferStatus == "cancelled" ? "(Cancelled)" : ""}</span>
                  <span onClick={() => {
                    if (purchaseOrder._id) {
                      toast.error("Purchase order is already created for this offer.");
                      return;
                    };
                    setShowRfqOfferEditProjectName(true)
                  }}>
                    <EditIcon
                      additionalClass={'h-4 cursor-pointer '}
                    />
                  </span></Fragment> : null}
            </h5>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", justifySelf: "left" }}>
              <Form.Select disabled={purchaseOrder?._id} onChange={handleCostSelect} defaultValue="default" style={{ maxWidth: "400px" }}>
                <option disabled value="default">Select a cost</option>
                <option value="Cost-1">Rapid</option>
                <option value="Cost-2">Standard</option>
                <option value="Cost-3">Economy</option>
              </Form.Select>

              <Form.Control disabled={purchaseOrder?._id} type="number" placeholder="Enter margin %" value={margin} onChange={handleMarginChange} />
              <p>(%)</p>

              <button
                onClick={handleSetMargin}
                style={{
                  padding: "6px 12px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                className="common-supplier-button"
              >
                Set Offer Price
              </button>

            </div>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
              <label style={{ marginRight: "10px", fontSize: "16px", marginTop: "10px" }}>Import 3D files</label>
              <Switch
                className="custom-switch"
                on={true}
                off={false}
                value={is3DFileOn}
                onChange={handle3DFileChange} // Toggle state on change
                style={{ marginLeft: '10px' }}
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", }}>
              <label style={{ marginRight: "10px", fontSize: "16px", marginTop: "10px" }}>Import 2D files</label>
              <Switch
                className="custom-switch"
                on={true}
                off={false}
                value={is2DFileOn}
                onChange={handle2DFileChange} // Toggle state on change
                style={{ marginLeft: '10px' }}
              />
            </div>


            {offerData?.partsData?.length > 0 ? (
              <div style={{ margin: "30px 0px", textAlign: "left" }}>
                {/* <h5 className="font-medium  my-1">Documentation required : </h5> */}
                <div className="!flex justify-between px-2 flex-wrap ">
                  <div>
                    <input
                      type="checkbox"
                      id="sign-check-cc"
                      name="checkbox"
                      value={offerData?.isConformanceCertificateRequested}
                      checked={offerData?.isConformanceCertificateRequested}
                      onChange={() => {
                        setOfferData({
                          ...offerData,
                          isConformanceCertificateRequested:
                            !offerData?.isConformanceCertificateRequested,
                        });
                      }}
                    />
                    {/* <label htmlFor="sign-check-cc">
                      Certificate of conformance
                    </label> */}
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="sign-check-dr"
                      name="checkbox"
                      value={offerData?.isDimensionalReportRequested}
                      checked={offerData?.isDimensionalReportRequested}
                      onChange={() => {
                        setOfferData({
                          ...offerData,
                          isDimensionalReportRequested:
                            !offerData?.isDimensionalReportRequested,
                        });
                      }}
                    />
                    {/* <label htmlFor="sign-check-dr" style={{ fontSize: "15px" }}>
                      Dimensional Inspection Report
                    </label> */}
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="sign-check-qr"
                      name="checkbox"
                      value={offerData?.isQrTrackingRequested}
                      checked={offerData?.isQrTrackingRequested}
                      onChange={() => {
                        setOfferData({
                          ...offerData,
                          isQrTrackingRequested:
                            !offerData?.isQrTrackingRequested,
                        });
                      }}
                    />
                    {/* <label htmlFor="sign-check-qr" style={{ fontSize: "15px" }}>
                      QR Tracking
                    </label> */}
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className="quotes-table">
              <table className="table">
                <thead>
                  <tr className="" style={{ fontSize: "0.9rem" }}>
                    <th scope="col">Snapshot</th>
                    <th scope="col" >Files</th>
                    <th scope="col">Part Description</th>
                    <th scope="col">Qty</th>
                    <th scope="col">Rapid</th>
                    <th scope="col">Standard</th>
                    <th scope="col">Economy</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {offerData?.partsData?.map((item, index) => {
                    return (
                      <>
                        <tr
                          key={index}
                          style={{ fontSize: "0.9rem" }}
                          className="!bg-white"
                        >
                          <td>
                            <p className="text-sm bold">
                              {
                                !isDfmInfoLoading ? <ThreeDViewerComponent
                                  item={item}
                                  selectedProcess={offerData?.selectedProcess}
                                  additionalClasses={'border !border-0'}
                                /> : <div className="flex items-center justify-center"><LucidLoader /></div>
                              }
                              <div class="flex items-start justify-start gap-x-2 ms-2 mt-3 w-full">
                                <button
                                  onClick={() => {
                                    //check condition 
                                    if (purchaseOrder._id) {
                                      toast.error("Purchase order is already created for this offer.");
                                      return;
                                    }
                                    if (item?.selectedFile) {
                                      //user have file
                                      inputRefs.current[index]?.click();
                                    }
                                    else {
                                      toast.error('Please upload a 3D file before adding a snapshot.');
                                    }
                                  }
                                  }
                                  class={`cursor-pointer text-center rounded text-[12px] text-black bg-gray-200 shadow-md py-2 px-3 transition duration-300 ${item?.thumbnail ? 'w-1/2' : 'w-full'
                                    }`}
                                >
                                  Upload
                                </button>
                                <input
                                  ref={(ref) => inputRefs.current[index] = ref}
                                  onChange={(e) => handleSnapShotUpload(e, item?._id, !!item?.thumbnail)}
                                  id={`file-upload-${index}`}
                                  type="file"
                                  accept="image/*"
                                  class="hidden"
                                />

                                {item?.thumbnail && (
                                  <button
                                    onClick={() => {
                                      if (purchaseOrder._id) {
                                        toast.error("Purchase order is already created for this offer.");
                                        return;
                                      }

                                      handleDeleteSnapshot(item?._id)
                                    }}
                                    class="w-1/2 text-center rounded text-[12px] text-white bg-red-500 hover:bg-red-600 shadow-md py-2 px-3 transition duration-300"
                                  >
                                    Delete
                                  </button>
                                )}
                              </div>
                            </p>
                          </td>

                          <td  >
                            {/* 3D File Section */}
                            <div >
                              {item?.selectedFile?.originalname ? (
                                <p className="text-sm bold">
                                  <FileName
                                    fileName={item?.selectedFile?.originalname}
                                    onDelete={() => {
                                      if (purchaseOrder._id) {
                                        toast.error("Purchase order is already created for this offer.");
                                        return;
                                      }
                                      setShowCaptchaModal(true);
                                      setCaptchaCallBack(() => () => handleSelectedFileRemove(index, "3D"));
                                      setButtonText('Delete')
                                    }}
                                    onDownload={async () => {
                                      const { originalname } = item?.selectedFile;
                                      if (originalname && originalname.endsWith('.pdf')) {
                                        const signedUrl = await getPresignedUrlForFile(item?.selectedFile.bucket, item?.selectedFile.key);
                                        setPdfModalInfo({
                                          show: true,
                                          pdfUrl: signedUrl,
                                          fileName: originalname,
                                        })
                                        return;
                                      }
                                      await downloadFileFromS3(item?.selectedFile)
                                    }}

                                  />
                                </p>
                              ) : (
                                <div className="my-1">
                                  <label
                                    className="white-btn cursor-pointer"
                                    onClick={() => {
                                      if (purchaseOrder._id) {
                                        toast.error("Purchase order is already created for this offer.");
                                        return;
                                      }
                                    }
                                    }
                                    htmlFor={!purchaseOrder._id ? `upload-3d-${index}` : undefined}
                                  >
                                    <span><UploadIcon additionalClass={'h-4'} /></span>
                                    <span className="mx-2 whitespace-nowrap">Upload 3D File for : Line {index + 1}</span>
                                  </label>
                                  <input
                                    disabled={purchaseOrder._id}
                                    className="border px-1"
                                    id={`upload-3d-${index}`}
                                    type="file"
                                    onChange={(e) => {
                                      let filesForCheck = Array.from(e.target.files);
                                      let isAllFilesValid = true;
                                      filesForCheck.forEach((file) => {
                                        if (file.size > 10485760) {
                                          isAllFilesValid = false;
                                        }
                                      });
                                      if (!isAllFilesValid) {
                                        toast.error("File size should be less than 10 MB");
                                        return;
                                      }
                                      handleFileUpload(e, index, "3D");
                                    }}
                                    style={{
                                      visibility: "hidden",
                                      height: "0px",
                                      width: "0px",
                                    }}
                                  />
                                </div>
                              )}
                            </div>

                            {/* 2D File Section */}
                            <div>
                              {item?.twoDFile?.originalname ? (
                                <p className="text-sm bold">
                                  <FileName
                                    fileName={item?.twoDFile?.originalname}
                                    onDelete={() => {
                                      if (purchaseOrder._id) {
                                        toast.error("Purchase order is already created for this offer.");
                                        return;
                                      }
                                      setShowCaptchaModal(true);
                                      setCaptchaCallBack(() => () => handleSelectedFileRemove(index, "2D"));
                                      setButtonText('Delete')
                                    }}
                                    onDownload={async () => {
                                      const { originalname } = item?.twoDFile;
                                      if (originalname && originalname.endsWith('.pdf')) {
                                        const signedUrl = await getPresignedUrlForFile(item?.twoDFile.bucket, item?.twoDFile.key);
                                        console.log('Signed URL for PDF:', signedUrl);
                                        setPdfModalInfo({
                                          show: true,
                                          pdfUrl: signedUrl,
                                          fileName: originalname,
                                        })
                                        return;
                                      }

                                      downloadFileFromS3(item?.twoDFile)
                                    }}

                                  />
                                </p>
                              ) : (
                                <div className="my-2">
                                  <label
                                    onClick={() => {
                                      if (purchaseOrder._id) {
                                        toast.error("Purchase order is already created for this offer.");
                                        return;
                                      }
                                    }}
                                    className="white-btn cursor-pointer"
                                    htmlFor={!purchaseOrder._id ? `upload-2d-${index}` : null}
                                  >
                                    <span><UploadIcon additionalClass={'h-4'} /></span>
                                    <span className="mx-2 whitespace-nowrap">Upload 2D File for : Line {index + 1}</span>
                                  </label>
                                  <input
                                    disabled={purchaseOrder?._id}
                                    className="border px-1"
                                    id={`upload-2d-${index}`}
                                    type="file"
                                    onChange={(e) => {
                                      let filesForCheck = Array.from(e.target.files);
                                      let isAllFilesValid = true;
                                      filesForCheck.forEach((file) => {
                                        if (file.size > 10485760) {
                                          isAllFilesValid = false;
                                        }
                                      });
                                      if (!isAllFilesValid) {
                                        toast.error("File size should be less than 10 MB");
                                        return;
                                      }
                                      handleFileUpload(e, index, "2D");
                                    }}
                                    style={{
                                      visibility: "hidden",
                                      height: "0px",
                                      width: "0px",
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </td>



                          <td
                            style={{
                              textAlign: "left",
                              wordWrap: "break-word",
                              wordBreak: "break-all",
                              whiteSpace: "normal",
                              minWidth: "200px",
                            }}
                          >{
                              offerData?.selectedProcess > 2 ?
                                <>
                                  <textarea
                                    disabled={purchaseOrder._id}
                                    className="border px-1"

                                    col="10"
                                    row="5"
                                    style={{ width: "100%" }}
                                    value={item.description ? item.description : ""}
                                    placeholder="Enter description"
                                    onChange={(e) =>

                                      handleRFQItemDescChange(
                                        e,
                                        index,
                                        "description"
                                      )
                                    }
                                  />
                                </> :
                                <>
                                  <input
                                    disabled={purchaseOrder._id}
                                    style={{ width: "100%" }}
                                    className="border px-1"
                                    value={
                                      item.description ? item.description : ""
                                    }
                                    placeholder="Enter description"
                                    onChange={(e) =>
                                      handleRFQItemDescChange(
                                        e,
                                        index,
                                        "description"
                                      )
                                    }
                                  />
                                  {isMaterialDataLoading ? (
                                    <div className="flex items-center justify-center"><LucidLoader /></div>
                                  ) : (
                                    <>
                                      {offerData?.selectedProcess === 1 && (
                                        <MetaDataInfoCncComponent
                                          item={item}
                                          fullMastersData={allCncMachineData}
                                          allData={fullMastersData}
                                          index={index}
                                          onSaveClick={handleMetaDataSave}
                                          isEditEnabled={!isPOAlreadyExists}
                                        />
                                      )}
                                      {offerData?.selectedProcess === 2 && (
                                        <MetaDataInfoThreeDComponent
                                          item={item}
                                          masterThreeDTechnologyData={masterThreeDTechnologyData}
                                          index={index}
                                          onSaveClick={handleMetaDataSave}
                                          isEditEnabled={!isPOAlreadyExists}
                                        />
                                      )}
                                    </>
                                  )}

                                </>

                            }

                          </td>


                          <td>
                            <input
                              disabled={purchaseOrder._id}
                              className="p-1  max-w-[80px] border outline-none"
                              value={item.qty}
                              placeholder="Quantity"
                              type="text"
                              onWheel={numberInputOnWheelPreventChange}
                              onKeyDown={(e) =>
                                ["e", "E", "+", "-"].includes(e.key) &&
                                e.preventDefault()
                              }
                              onChange={(e) => handleRFQItemQtyChange(e, index)}
                            />
                          </td>

                          <td className="flex flex-col">
                            <input
                              disabled={purchaseOrder._id}
                              className="un-fld border p-1"
                              type="text"
                              name="offerPrice1"
                              value={item.offerPrice1 || ''}
                              onChange={(e) => {
                                handleRFQItemPriceChange(e, index);
                              }}
                            />
                            <p style={{ whiteSpace: "nowrap" }}>QP - {item.mainPrice1 ? currencyFormatter((item.mainPrice1).toFixed(2)) : ""}</p>
                          </td>

                          <td className="">
                            <input
                              disabled={purchaseOrder._id}
                              className="un-fld border p-1"
                              type="text"
                              name="offerPrice2"
                              value={item.offerPrice2 || ''}
                              onChange={(e) => {
                                handleRFQItemPriceChange(e, index);
                              }}
                            />
                            <p style={{ whiteSpace: "nowrap" }} >QP - {item.mainPrice2 ? currencyFormatter((item.mainPrice2).toFixed(2)) : ""}</p>


                          </td>

                          <td>
                            <input
                              disabled={purchaseOrder._id}
                              className="un-fld border p-1"
                              type="text"
                              name="offerPrice3"
                              value={item.offerPrice3 || ''}
                              onChange={(e) => {
                                handleRFQItemPriceChange(e, index);
                              }}
                            />
                            <p style={{ whiteSpace: "nowrap" }}>QP - {item.mainPrice3 ? currencyFormatter((item.mainPrice3).toFixed(2)) : ""}</p>
                          </td>

                          <td >
                            <div className="flex flex-col justify-center items-center gap-y-2">
                              <button className="px-2 py-0.5 text-sm bg-red-500 min-w-[70px] text-white rounded mx-1" onClick={() => {

                                if (purchaseOrder._id) {
                                  toast.error("Purchase order is already created for this rfq.");
                                  return;
                                }
                                handleDeleteRow(index)
                              }}>Del</button>
                              <button className="px-2 py-0.5 text-sm bg-yellow-400 min-w-[70px] text-white rounded " onClick={() => {
                                if (purchaseOrder._id) {
                                  toast.error("Purchase order is already created for this offer.");
                                  return;
                                }
                                handleClone(index)
                              }}>Clone</button>
                            </div>
                          </td>

                        </tr >

                      </>
                    );

                  })}
                  <tr style={{ fontSize: "0.9rem" }}
                    className="!bg-white">

                    <td></td>
                    <td></td>
                    <td></td>

                    <td className="!whitespace-nowrap" >Total</td>
                    <td>
                      <div style={{ maxWidth: "80px" }}>
                        <b>
                          {totalAmounts?.totalAmount1 ? currencyFormatter(totalAmounts?.totalAmount1) : "0.00"}
                        </b>
                        <p style={{ whiteSpace: "nowrap" }} >QP - {selectedQuote?.price1 ? currencyFormatter((selectedQuote.price1).toFixed(2)) : ""}</p>
                      </div>
                    </td>
                    <td>
                      <div style={{ maxWidth: "80px" }}>
                        <b>
                          {totalAmounts?.totalAmount2 ? currencyFormatter(totalAmounts?.totalAmount2) : "0.00"}
                        </b>
                        <p style={{ whiteSpace: "nowrap" }} >QP - {selectedQuote?.price2 ? currencyFormatter((selectedQuote.price2).toFixed(2)) : ""}</p>

                      </div>
                    </td>
                    <td>
                      <div style={{ maxWidth: "80px" }}>
                        <b>
                          {totalAmounts?.totalAmount3 ? currencyFormatter(totalAmounts?.totalAmount3) : "0.00"}
                        </b>
                        <p style={{ whiteSpace: "nowrap" }} >QP - {selectedQuote?.price3 ? currencyFormatter((selectedQuote.price3).toFixed(2)) : ""}</p>

                      </div>
                    </td>

                    <td>

                    </td>

                  </tr>
                  <tr style={{ fontSize: "0.9rem" }} className="!bg-white">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td className="!whitespace-nowrap" >Lead Time</td>
                    {["leadTime1", "leadTime2", "leadTime3"].map((field, index) => (
                      <td key={field}>
                        <div style={{ maxWidth: "80px" }}>
                          <input
                            disabled={purchaseOrder?._id}
                            className="un-fld border p-1"
                            type="text"
                            name={field}
                            onWheel={numberInputOnWheelPreventChange}
                            value={leadTimes[field] || ""}
                            placeholder="Days"
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                            }
                            onChange={(e) => handleOfferLeadTimeChange(e)}
                          />
                          <p className="whitespace-nowrap mt-1">
                            {leadTimes[field]
                              ? `${leadTimes[field]} business days`
                              : ""}
                          </p>

                        </div>
                      </td>
                    ))}
                    <td></td>
                  </tr>

                </tbody>
              </table>
              <div style={{ textAlign: "left" }}>
                <h6 className="font-medium my-1">Admin Comments :&nbsp;&nbsp;</h6>
                <textarea
                  disabled={purchaseOrder?._id}
                  rows="3"
                  className="p-1"
                  style={{ width: "100%" }}
                  placeholder="Enter comment here"
                  value={offerData?.adminComment}
                  onChange={(e) =>
                    setOfferData({ ...offerData, adminComment: e.target.value })
                  }
                ></textarea>
              </div>

              <div style={{ textAlign: "left", marginBottom: "20px" }}>
                <button
                  className="common-supplier-button"
                  onClick={() => handleUpdateRFQPartData("manully")}
                >
                  Update offer data
                </button>
                {!isBatchFileDownloading ? <button
                  className=" max-w-[300px] bg-[#DC712B] text-white text-sm rounded px-2.5 py-1.5 transition duration-400 no-underline border-none mt-1.5 mr-2 ml-auto whitespace-nowrap !w-[400px]"
                  onClick={handleBatchClick}
                >
                  Batch download all technical drawings

                </button> : <button
                  className=" max-w-[300px] bg-[#DC712B] text-white text-sm rounded px-2.5 py-1.5 transition duration-400 no-underline border-none mt-1.5 mr-2  !w-[300px]"
                  onClick={handleBatchClick}
                >
                  <div className="mx-auto mt-2"><LucidLoader /></div>


                </button>}

                <button
                  className="common-supplier-button"
                  onClick={ErrorCheckHOF(() => navigate(`/admin/admin-quote/${offerData?.quotationId}`))
                  }
                >
                  Go to quotation{" "}
                </button>
                {purchaseOrder?._id ? <button
                  className="common-supplier-button"
                  onClick={ErrorCheckHOF(() => navigate(`/admin/purchase-order-details/${purchaseOrder?._id}`))
                  }
                >
                  Go to PO
                </button> : null}

                {!isPOAlreadyExists && <button
                  className="common-supplier-button"
                  onClick={handleCancelRFQ}
                >
                  Delete offer
                </button>}
                {rfqOfferAdditionalData?.rfqOffer?._id ? <button
                  className="common-supplier-button"
                  onClick={() => navigate('/admin/rfq-details/' + rfqOfferAdditionalData?.rfqOffer?._id)}
                >
                  Go to linked rfq
                </button> : null}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: "13px",
                flexWrap: "wrap",
              }}
            >
              <div>
                <Form.Select
                  onChange={(e) =>
                    setSelectedSupplier(JSON.parse(e.target.value))
                  }
                  defaultValue="default"
                  style={{ minWidth: "400px", marginTop: "10px" }}
                >
                  <option disabled value="default">
                    Select a supplier
                  </option>
                  {supplierList.map((item, i) => {
                    return (
                      <option key={i} value={JSON.stringify(item)}>
                        {item.companyName}
                      </option>
                    );
                  })}
                </Form.Select>
              </div>

              <div>
                <button
                  onClick={handleAddSupplier}
                  className="common-supplier-button"
                  style={{ minWidth: "150px", marginTop: "10px" }}
                >
                  Add Supplier
                </button>
              </div>
            </div>

            <br />
            {supplierRFQs.length > 0 ? (
              <>
                <table className="supplierTable">
                  <thead>
                    <tr>
                      <th>Choose Supplier</th>
                      <th>Supplier</th>
                      <th>LeadTime</th>
                      <th>Days since Offer</th>
                      <th>Email</th>
                      <th>Chat</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {supplierRFQs.map((item, i) => {
                      console.log("Item ::", item);
                      return (
                        <tr key={i}>
                          <td
                            style={{
                              textAlign: "center",
                              wordWrap: "break-word",
                              wordBreak: "break-all",
                              whiteSpace: "normal",
                              width: "30px",
                            }}
                          >
                            <Switch
                              className="custom-switch"
                              on="true"
                              off="false"
                              value={item?.isSelected?.toString()}
                              disabled={offerData?.rfqOfferStatus === 'cancelled'}
                              onChange={() => handleSwitchClick(item)}
                            />
                          </td>
                          <td className="d-flex align-items-center" style={{ gap: "10px", flexWrap: "wrap" }}>
                            <div style={{ flex: "1", minWidth: "200px" }}>
                              <strong>{item?.supplierId?.companyName}</strong> &nbsp; (
                              <span>{item?.supplierId?.supplierRefId}</span>)
                            </div>
                            <div style={{ flex: "1", minWidth: "150px" }}>
                              <Form.Select
                                value={item?.selectedOfferMethod}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let price;
                                  if (value == 1) {
                                    price = totalAmounts.totalAmount1;
                                  }
                                  else if (value == 2) {
                                    price = totalAmounts.totalAmount2;
                                  }
                                  else if (value == 3) {
                                    price = totalAmounts.totalAmount3;
                                  }
                                  handleSupplierOfferSelectedMethodChange(value, i)
                                  handleSupplierCostSelect(
                                    price,
                                    item._id,
                                    item.status,
                                    e.target.selectedIndex // Pass the selected index
                                  )
                                }

                                }
                                defaultValue=""
                                style={{ minWidth: "150px" }}
                                defa
                              >
                                <option value={0} >
                                  Select Cost
                                </option>
                                {totalAmounts.totalAmount1 > 0 && (
                                  <option value={1}>
                                    {`Rapid ${currencyFormatter(totalAmounts.totalAmount1)}`}
                                  </option>
                                )}

                                {totalAmounts.totalAmount2 > 0 && (
                                  <option value={2}>
                                    {`Standard ${currencyFormatter(totalAmounts.totalAmount2)}`}
                                  </option>
                                )}

                                {totalAmounts.totalAmount3 > 0 && (
                                  <option value={3}>
                                    {`Economy ${currencyFormatter(totalAmounts.totalAmount3)}`}
                                  </option>
                                )}
                              </Form.Select>

                            </div>
                          </td>
                          <td
                            style={{
                              textAlign: "left",
                              wordWrap: "break-word",
                              wordBreak: "break-all",
                              whiteSpace: "normal",
                              width: "150px",
                            }}
                          >
                            {item?.leadTime ? (
                              <>
                                <p style={{ marginBottom: "0px" }}>
                                  {item?.leadTime + " business Days"}
                                </p>
                              </>
                            ) : (
                              ""
                            )}

                          </td>

                          <td style={{ textAlign: "center" }}>
                            {item.receivedDate ? (
                              <>
                                {Math.abs(
                                  moment(item.receivedDate).diff(
                                    item?.quoteSubmitDate,
                                    "days"
                                  )
                                )}
                              </>
                            ) : (
                              <>
                                {Math.abs(
                                  moment(item.createdAt).diff(
                                    item?.quoteSubmitDate,
                                    "days"
                                  )
                                )}
                              </>
                            )}
                          </td>

                          <td
                            style={{
                              textAlign: "left",
                              wordWrap: "break-word",
                              wordBreak: "break-all",
                              whiteSpace: "normal",
                              minWidth: "150px",
                            }}
                          >
                            {" "}
                            {item.isReceived ? (
                              <>
                                Offer Sent on{" "}
                                {moment(item.receivedDate).format(
                                  "MMM DD, YYYY"
                                )}
                                <p style={{ fontWeight: "bolder" }}>
                                  ({item.status})
                                  <br />
                                  {/* {item.isOfferDeclined ? (
                                    <>
                                      <button
                                        onClick={() =>
                                          handleShowDeclinedDetails(item._id)
                                        }
                                        style={{
                                          minWidth: "90px",
                                        }}
                                      >
                                        View Reason
                                      </button>
                                    </>
                                  ) : (
                                    <></>
                                  )} */}
                                  {item.poCreationDate ? (
                                    <>
                                      {" "}
                                      Po created on{" "}
                                      {moment(item.poCreationDate).format(
                                        "DD MMM YYYY"
                                      )}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </p>
                              </>
                            ) : (
                              <>
                                {(supplierRFQs[i].status != 'Not Available') ? <button
                                  onClick={ErrorCheckHOF(() => {
                                    if (supplierRFQs[i].selectedOfferMethod <= 0) {
                                      toast.error("Please select valid price ");
                                      return;
                                    }
                                    if (!isDefaultOrganizationAddressExists) {
                                      toast.error("Please add default organization address before sending offer.");
                                      return;
                                    }

                                    // setShowCaptchaModal(true);
                                    // setCaptchaCallBack(() => () => handleSendRFQEmail(item._id));
                                    setButtonText('Send email');
                                    setIsModalVisible(true);
                                    console.log("Email List ::", item?.supplierId?.emailList);
                                    setSelectedEmailLIstForSupplier(item?.supplierId?.emailList);
                                    setSelectedRFQForMail(item._id);

                                  })}
                                  disabled={supplierRFQs[i].status == 'Not Available'}
                                  style={{
                                    minWidth: "90px",
                                  }}
                                >
                                  Send Offer
                                </button> : <p style={{ fontWeight: "bolder" }}>
                                  {(item.status)}
                                </p>}
                                {/* <button
                                  onClick={ErrorCheckHOF(() => {
                                    if (supplierRFQs[i].selectedOfferMethod <= 0) {
                                      toast.error("Please select valid price");
                                      return;
                                    }
                                    if (!isDefaultOrganizationAddressExists) {
                                      toast.error("Please add default organization address before sending offer.");
                                      return;
                                    }
                                    // handleUpdateRFQPartData("mail");
                                    handleMarkAsSentRFQ(item._id, supplierRFQs[i].selectedOfferMethod)
                                  })}
                                  style={{
                                    minWidth: "90px",
                                    marginTop: "5px",
                                  }}
                                >
                                  Mark As Sent
                                </button> */}
                              </>
                            )}
                          </td>
                          <td >
                            <Chat
                              RefId={item?.supplierRFQRefId}
                              open={item?.supplierRFQRefId == selectedChatRefId}
                              onDrawerClose={onClose}
                            />
                            <ChatButton
                              RefId={item?.supplierRFQRefId}
                              showDrawer={() =>
                                showSupplierDrawer(item?.supplierRFQRefId)
                              }
                              color={"white"}
                              additionalClass={'!bg-[#DC712B] hover:bg-[#bd5612]  w-max px-2 !h-8'}
                            />
                            {/* </button> */}
                          </td>
                          <td>
                            {!item?.isSelected ? <>
                              <button onClick={() => handleDeleteRFQ(item._id)}>
                                Delete
                              </button>
                            </> :
                              <>
                                PO Created
                              </>}

                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </span >


    </div >
  );
};

export default OffersDetails;
